/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Icon } from 'semantic-ui-react';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  link: NavigationContentLink,
  onTitleChange: (title: string) => void,
};

const NavigationLinkForm = ({ link, onTitleChange }: Props) => {
  const onChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onTitleChange(event.target.value);
    }
  };

  return (
    <Form>
      <Form.Input label="Titre" value={link.title} onChange={onChange} />
      <Form.Input
        iconPosition="left"
        label="Liaison vers la page"
        value={link.page.name}
        readOnly
        action
      >
        <Icon name="chevron right" />
        <input />
        <Link
          to={`/pages/${link.page.id}`}
          target="innoctopus"
          className="ui button"
        >
          Editer
        </Link>
      </Form.Input>
    </Form>
  );
};

export default NavigationLinkForm;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinkForm.js